import React, {useEffect, useState,} from "react";
import {BackIcon} from "../../../../assets/icons/profileIcons";
import {useNavigate, useParams} from "react-router-dom";
import {Col, notification, Row,} from "antd";
import {AnniversaryIcon, CakeIcon,} from "../../../../assets/icons/sidebarIcons";
import DescriptionInput from "../../../components/common/description-field/DescriptionField";
import {Form} from "react-bootstrap";
import {Controller, useForm} from "react-hook-form";
import {checkEmptySpaces, maxLength, Required,} from "../../../utils/patterns";
import ThemeButton from "../../../components/common/theme-button/ThemeButton";
import {RoundedCheck,} from "../../../../assets/icons/defaultIcons";
import {EditCoachSessions, GetSingleCoachSessions,} from "../../../services/coaching.service";
import {formateDate} from "../../../utils/constant";
import dayjs from "dayjs";
import ThemeDatePicker from "../../../components/common/date-picker/ThemeDatePicker";
import ClientNoteDetailsSkeleton from "../../skeletons/coaching/ClientNoteDetailsSkeleton";
import DemoImage from "../../../../assets/images/d-image.png";

const EditNote = () => {
    let { id } = useParams();
    let navigate = useNavigate();
    const [sessionEdit, setSessionEdit] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [loader, setLoader] = useState(false);
    const [clientSingleData, setClientSingleData] = useState(null);
    const [alertModalIsOpen, setAlertModalIsOpen] = useState(false);

    let todayData = new Date();

    const {
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
        control,
        clearErrors,
        watch,
    } = useForm({
        mode: "onChange",
    });

    const onSubmit = async (data) => {
        setLoader(true)
        let payload = {
            clientId: clientSingleData?.clientId,
            coachingStart: data?.start_date,
            coachingEnd: data?.end_date,
            sessionNote: data?.session_note,
            coachNote: data?.coach_note,
            actionItems: data?.action_items,
        };
        try {
            let res = await EditCoachSessions(payload, id);
            if (res?.data?.data?.status) {
                notification.success({
                    message: "Success",
                    description: res?.data?.data?.message,
                    placement: "topRight",
                    icon: <RoundedCheck />,
                    duration: 2,
                });
            }
        } catch (error) {
            console.log("ThisIsErr", error);
            console.log("ThisIsErr2", error?.response);
        } finally {
            setLoader(false)
            navigate(`/coaching/client-details/${clientSingleData?.clientId}`)
        }
    };

    const HandleBack = () => {
        navigate(-1);
    };

    const GetSingleSession = async (searchTerm) => {
        setIsLoading(true)
        let response = await GetSingleCoachSessions(id);
        setClientSingleData(response?.data?.data?.data);
        const payload = {
            // start_date: clientSingleData.coachingStart ,
            start_date: dayjs(formateDate(response?.data?.data?.data?.coachingStart), "MM/DD/YYYY") ,
            end_date: dayjs(formateDate(response?.data?.data?.data?.coachingEnd), "MM/DD/YYYY") ,
            session_note: response?.data?.data?.data?.sessionNote,
            coach_note: response?.data?.data?.data?.coachNote,
            action_items: response?.data?.data?.data?.actionItems,
        };
        reset(payload);
        setIsLoading(false)
    };

    useEffect(()=>{
        GetSingleSession()
    },[])

    if (isLoading) {
        return <ClientNoteDetailsSkeleton/>;
    }

    return (
        <>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className="main_div_client_details">
                    <div className="inner_div">
                        <div className="header">
              <span onClick={HandleBack}>
                <BackIcon />
              </span>
                            <h3>{clientSingleData?.client[0]?.fullName}</h3>
                        </div>

                        <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
                            <Col lg={24} xl={24} md={24}>
                                <div className="col_1_div">
                                    <div className="inner_div_col_1">
                                        <div className="client_info">
                                            <div className="inner_client_info">
                                                <p>Client Info</p>
                                                {/*                        <span onClick={() => setModalIsOpen(true)}>*/}
                                                {/*  <PenIconSession />*/}
                                                {/*</span>*/}
                                            </div>
                                            <div className="profile">
                                                <div className="img_div">
                                                    <img src={clientSingleData?.client[0]?.profileImage || DemoImage} />
                                                </div>
                                                <div>
                                                    <p>{clientSingleData?.client[0]?.fullName}</p>
                                                    <p className="para">{clientSingleData?.client[0]?.email}</p>
                                                </div>
                                            </div>
                                            <div className="events_section">
                                                <div className="inner_events">
                                                    <CakeIcon />
                                                    <p>Birthday</p>
                                                </div>
                                                <p>
                                                    {clientSingleData?.client[0]?.dob !== "" && clientSingleData?.client[0]?.dob
                                                        ? formateDate(clientSingleData?.client[0]?.dob)
                                                        : "-"}
                                                </p>
                                            </div>
                                            <div className="events_section">
                                                <div className="inner_events">
                                                    <AnniversaryIcon />
                                                    <p>Anniversary</p>
                                                </div>

                                                <p>
                                                    {clientSingleData?.anniversary !== null &&
                                                    clientSingleData?.anniversary
                                                        ? formateDate(clientSingleData?.anniversary)
                                                        : "-"}
                                                </p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </Col>
                            <Col lg={12} xl={12} md={24}>
                                <div className={'col_1_div'}>
                                    <div className={'inner_div_col_1'}>
                                        <div>
                                            <div className={"dfields"}>
                                                <Controller
                                                    name="start_date"
                                                    // defaultValue={"Evan"}
                                                    control={control}
                                                    rules={{
                                                        required: Required,
                                                    }}
                                                    render={({ field: { name, ...field } }) => (
                                                        <ThemeDatePicker
                                                            label={"Coaching Start Date"}
                                                            field={field}
                                                            fieldName={name}
                                                            errors={errors.start_date}
                                                            setValue={setValue}
                                                            defaultValue={dayjs(formateDate(clientSingleData?.coachingStart), "MM/DD/YYYY")}
                                                        />
                                                    )}
                                                />
                                            </div>
                                            <div className={"dfields"}>
                                                <Controller
                                                    name="end_date"
                                                    // defaultValue={"Evan"}
                                                    control={control}
                                                    rules={{
                                                        required: Required,
                                                    }}
                                                    render={({ field: { name, ...field } }) => (
                                                        <ThemeDatePicker
                                                            label={"Coaching End Date"}
                                                            field={field}
                                                            fieldName={name}
                                                            errors={errors.end_date}
                                                            setValue={setValue}
                                                            defaultValue={dayjs(formateDate(clientSingleData?.coachingEnd), "MM/DD/YYYY")}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="session_main_div">
                                            <h5>Session Note:</h5>
                                            <div className={"dfields"}>
                                                <Controller
                                                    name="session_note"
                                                    defaultValue={clientSingleData?.session_note}
                                                    control={control}
                                                    rules={{
                                                        required: Required,
                                                        maxLength: maxLength(2000),
                                                        validate: checkEmptySpaces,
                                                    }}
                                                    render={({ field: { name, ...field } }) => (
                                                        <DescriptionInput
                                                            rows={15}
                                                            autoSize={{ minRows: 15, maxRows: 16 }}
                                                            placeholder={"Write your session notes here..."}
                                                            label={""}
                                                            type={"text"}
                                                            field={field}
                                                            errors={errors.session_note}
                                                            defaultValue={clientSingleData?.session_note}
                                                            className={"required"}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={"dfields d-none d-lg-block"}>
                                    <ThemeButton
                                        text={"Submit"}
                                        className={"btn-light-lg"}
                                        type={"submit"}
                                        loader={loader}
                                    />
                                </div>
                            </Col>
                            <Col lg={12} xl={12} md={24}>
                                <div className="col_1_div">
                                    <div className="inner_div_col_1">
                                        <div className="form_div">
                                            <h5>Coach Note</h5>

                                            <div className={"dfields"}>
                                                <Controller
                                                    name="coach_note"
                                                    // defaultValue={"Evan"}
                                                    control={control}
                                                    rules={{
                                                        required: Required,
                                                        maxLength: maxLength(2000),
                                                        validate: checkEmptySpaces,
                                                    }}
                                                    render={({ field: { name, ...field } }) => (
                                                        <DescriptionInput
                                                            rows={10}
                                                            autoSize={{ minRows: 10, maxRows: 11 }}
                                                            placeholder={"Write your coaching notes here..."}
                                                            label={""}
                                                            type={"text"}
                                                            field={field}
                                                            errors={errors.coach_note}
                                                            className={"required"}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="form_div">
                                            <h5>Action Items</h5>

                                            <div className={"dfields"}>
                                                <Controller
                                                    name="action_items"
                                                    // defaultValue={"Evan"}
                                                    control={control}
                                                    rules={{
                                                        required: Required,
                                                        maxLength: maxLength(2000),
                                                        validate: checkEmptySpaces,
                                                    }}
                                                    render={({ field: { name, ...field } }) => (
                                                        <DescriptionInput
                                                            rows={10}
                                                            autoSize={{ minRows: 10, maxRows: 11 }}
                                                            placeholder={"Write a action description here..."}
                                                            label={""}
                                                            type={"text"}
                                                            field={field}
                                                            errors={errors.action_items}
                                                            className={"required"}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={"dfields d-block d-lg-none"}>
                                    <ThemeButton
                                        text={"Submit"}
                                        className={"btn-light-lg"}
                                        type={"submit"}
                                        loader={loader}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Form>
        </>
    );
};

export default EditNote;
